import { ItemDiscountConfigVariants } from 'apis/restaurant-api/merchant-admin/campaigns/types';

import { ItemDiscountType } from '../types';

export const getItemDiscountType = (itemDiscountConfig: ItemDiscountConfigVariants): ItemDiscountType => {
  if (itemDiscountConfig.amount !== null) {
    return ItemDiscountType.AMOUNT_OFF;
  }

  if (itemDiscountConfig.percentage !== null) {
    return ItemDiscountType.PERCENTAGE_OFF;
  }

  return ItemDiscountType.X_FOR_FREE;
};
